import { render, staticRenderFns } from "./AllDiseasesList.vue?vue&type=template&id=c7cad428&scoped=true&"
import script from "./AllDiseasesList.vue?vue&type=script&lang=js&"
export * from "./AllDiseasesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7cad428",
  null
  
)

export default component.exports